import { useApiErrorStore } from '@/stores/apiErrorStore';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { AiOutlineWarning } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

export default function RateLimitPage() {
  const navigate = useNavigate();

  const isRateLimited = useApiErrorStore((s) => s.isRateLimited);
  const getRemainingSeconds = useApiErrorStore((s) => s.getRemainingSeconds);
  const clearError = useApiErrorStore((s) => s.clearError);

  const [countdown, setCountdown] = useState(null);

  useEffect(() => {
    if (!isRateLimited()) {
      navigate('/');
      return;
    }

    const timer = setInterval(() => {
      const remaining = getRemainingSeconds();

      if (remaining <= 0) {
        clearInterval(timer);
        clearError();
        sessionStorage.removeItem('rateLimitEndTime');
        navigate('/');
      } else {
        setCountdown(remaining);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [isRateLimited, getRemainingSeconds, clearError, navigate]);

  return (
    <motion.div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-primary-600 to-primary-500 text-white p-6">
      <AiOutlineWarning className="w-20 h-20 mb-6" />
      <h1 className="text-lg font-bold mb-4">Terlalu Banyak Permintaan</h1>
      <p className="mb-6 text-center">Silakan tunggu beberapa detik sebelum mencoba lagi.</p>
      <div className="text-2xl font-mono bg-white/20 px-6 py-3 rounded-xl">
        {countdown !== null ? `${countdown} detik` : '...'}
      </div>
    </motion.div>
  );
}
